// errors
export const ERROR_TECNICO = "error-1";
export const INDIVIDUO_NEGATIVO = "error-2";
export const RECHAZADO = "error-3";
export const ERROR_NOSIS = "error-4";
export const RECHAZADO_OTROS = "error-5";
export const CLIENTE_NO_CENSADO = "clienteNoCensado";
export const ERROR_CONFIRMACION_RENAPER = "error-renaper";
export const GRACIAS = "gracias";
export const ERROR_SOLICITUD = "error-solicitud";
export const ERROR_CONEXION = "error-conexion";
export const ERROR_VERIDAS_RESULT = "error-veridas-result";
export const ERROR_REINTENTOS_BIOMETRIA = "error-reintentos-biometria";
export const ERROR_VERIDAS_CA = "error-veridas-ca";
export const ERROR_SERVICIO_VERIDAS = "error-servicio-veridas";
export const ERROR_TOKEN_EXPIRED = "error-tokenExpired";
export const ERROR_DNI = "error-dni";
export const ERROR_REGISTRAR_DOMICILIO = "error-registrar-domicilio";
export const ERROR_INICIO_VERIDAS = "error-inicio-veridas";
export const ERROR_HABILITA_PERMISOS = "error-habilita-permisos";
export const ERROR_SELFIE = "error-selfie";
export const ERROR_SERVICIO_ASO = "error-servicio-aso";
export const ERROR_SERVICIO_RENAPER = "error-servicio-renaper";
export const ERROR_SERVIDOR = "error-servidor";
export const YA_CONTRATO = "ya-contrato";
export const DATOS_INCORRECTOS = "datos-incorrectos";
export const ERROR_CELULAR = "error-celular";
export const ERROR_DOMICILIO = "error-domicilio";
export const ERROR_CONYUGE = "error-conyuge";
export const ERROR_EMAIL = "error-email";
